import { render } from "./PhotoView.vue?vue&type=template&id=004690e8&scoped=true&ts=true"
import script from "./PhotoView.vue?vue&type=script&lang=ts"
export * from "./PhotoView.vue?vue&type=script&lang=ts"

import "./PhotoView.vue?vue&type=style&index=0&id=004690e8&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004690e8"]])

export default __exports__